<template>
    <div class="flex-c flex1">
        <div class="flex1 home-view" :class="$themeStyle($store.state.theme.theme)">
            <el-carousel height="624px" trigger="click">
                <el-carousel-item v-for="(item, index) in imageList" :key="index"
                    :class="$themeStyle($store.state.theme.theme)">
                    <el-image style="width: 100%; height: 624px" fit="cover" :src="item.url"></el-image>
                </el-carousel-item>
            </el-carousel>
            <div class="center-box" v-show="showCard">
                <div class="center-inner" :class="$themeStyle($store.state.theme.theme)">
                    <div class="flex flex-j-sa">
                        <HomePageSearch v-show="scrollTop < 600" />
                        <div style="height: 60px; width: 2px" v-show="scrollTop > 599" />
                    </div>
                    <HomeTitle title="热门好课" subTitle="精选热门课程，实时更新" v-if="hotCourseList.length" />
                    <el-row :gutter="16" v-if="hotCourseList.length">
                        <el-col :sm="12" :md="8" :lg="4" v-for="(item, index) in hotCourseList" :key="index">
                            <CourseCard :details="item" />
                        </el-col>
                    </el-row>
                    <div v-for="(courseObj, courseObjIndex) in courseTypeList" :key="courseObjIndex">
                        <div class="flex flex-j-sb align-center" v-if="courseObj.show">
                            <HomeTitle :icon="1" :title="courseObj.name" :subTitle="courseObj.notes" />
                            <ShowMore @showMore="showMore" />
                        </div>
                        <el-row :gutter="16" v-if="courseObj.show">
                            <el-col :sm="12" :md="8" :lg="4" v-for="(item, index) in courseObj.courseList" :key="index">
                                <CourseCard :details="item" />
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    homeHotCourseList,
    courseTypeList,
    homeCrouseByType,
} from "@/api/course.js";
import HomeTitle from "./components/HomeTitle.vue";
import CourseCard from "@/components/CourseCard";
import HomePageSearch from "./components/HomePageSearch";
export default {
    components: {
        HomeTitle,
        CourseCard,
        HomePageSearch,
    },
    name: "HomePage",
    data() {
        return {
            imageList: [
                {
                    url: require('../../assets/大脑.png'),

                },
                {
                    url: require('../../assets/街巷.png'),

                }
            ],
            scrollTop: 0,
            timer: null,
            courseTypeList: [],
            hotCourseList: [],
            showCard: false,
        };
    },
    created() { },
    mounted() {
        this.getData();
        window.addEventListener("scroll", this.scrolling);
    },
    methods: {
        getData() {
            this.getCourseType();
            this.getHotCourse();
        },
        /* 获取课程分类 */
        getCourseType() {
            courseTypeList().then((res) => {
                const { code, data } = res;
                if (code === 200) {
                    this.courseTypeList = data;
                    for (let i = 0; i < data.length; i++) {
                        this.courseTypeList[i].courseList = [];
                        this.courseTypeList[i].show = false;
                        this.getCourseByType(data[i].id);
                    }
                }
            });
        },
        /* 通过分类获取课程 */
        getCourseByType(id) {
            homeCrouseByType({ typeId: id }).then((res) => {
                const { code, data } = res;
                if (code === 200 && data.length) {
                    const index = this.courseTypeList.findIndex(
                        (item) => item.id === id
                    );
                    this.courseTypeList[index].courseList = data;
                    this.courseTypeList[index].show = data.length > 0;
                    this.showCard = true;
                }
            });
        },
        /* 获取热门课程 */
        getHotCourse() {
            homeHotCourseList().then((res) => {
                const { code, data } = res;
                if (code === 200) {
                    this.hotCourseList = data;
                }
            });
        },
        scrolling() {
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            let scrollStep = scrollTop - this.oldScrollTop;
            this.oldScrollTop = scrollTop;
            if (scrollStep > 0) {
                clearInterval(this.timer);
            }
            this.scrollTop = scrollTop;
        },
        showMore() {
            this.$router.push("/student/courseList");
        },
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.scrolling);
    },
};
</script>

<style scoped lang="scss">
.home-view {
    margin-top: -74px;

    .center-box {
        padding: 0 60px;
        margin-top: -152px;
        z-index: 99;
        position: relative;
        min-height: 500px;

        .center-inner {
            border-top-left-radius: 50px;
            border-top-right-radius: 50px;
            padding: 50px;
            box-shadow: none;
        }
    }
}

::v-deep .el-carousel--horizontal {
    overflow: hidden;
}

::v-deep .el-carousel__indicators--horizontal {
    bottom: 152px;
}
</style>
